// Test IDs for the photo-scan flow.
export const SCAN = {
    root: 'scan-root',
    triggerInPicker: 'scan-trigger-in-picker',
    triggerInSession: 'scan-trigger-in-session',
    fileInput: 'scan-file-input',
    cameraInput: 'scan-camera-input',
    previewImage: 'scan-preview-image',
    analyzeBtn: 'scan-analyze-btn',
    retakeBtn: 'scan-retake-btn',
    cancelBtn: 'scan-cancel-btn',
    confidenceBadge: 'scan-confidence-badge',
    extractionForm: 'scan-extraction-form',
    nameInput: 'scan-name-input',
    categorySelect: 'scan-category-select',
    equipmentSelect: 'scan-equipment-select',
    musclesInput: 'scan-muscles-input',
    weightInput: 'scan-weight-input',
    commitBtn: 'scan-commit-btn',
    errorMessage: 'scan-error',
};
